import { render, staticRenderFns } from "./OperaArticleWindow.vue?vue&type=template&id=0290edd4&scoped=true&"
import script from "./OperaArticleWindow.vue?vue&type=script&lang=js&"
export * from "./OperaArticleWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaArticleWindow.vue?vue&type=style&index=0&id=0290edd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0290edd4",
  null
  
)

export default component.exports